export const GET_ADMIN_QUESTION_REQUEST = " GET_ADMIN_QUESTION_REQUEST";
export const GET_ADMIN_QUESTION_SUCCESS = " GET_ADMIN_QUESTION_SUCCESS";
export const GET_ADMIN_QUESTION_FAILURE = " GET_ADMIN_QUESTION_FAILURE";
